module.exports = __webpack_public_path__ + "img/32.1eeee26d.svg";